import { AxiosResponse } from "axios";

import API from "../api";

import { Screenshot } from "../models/screenshot";

const ROUTE_NAME = "screenshots";

const ScreenshotService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Screenshot>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Screenshot[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(screenshot: Screenshot): Promise<AxiosResponse<Screenshot>> {
    return await API.post(`/${ROUTE_NAME}`, screenshot);
  },
  async update(id: number, screenshot: Screenshot): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, screenshot);
  },
  async delete(id: number): Promise<AxiosResponse<Screenshot>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default ScreenshotService;
